import $ from 'jquery';

export default function () {
	$('.c-footer__scroll').click(function() {
		$('html, body').animate({ scrollTop: 0 }, 1500);
		return false;
	})

}